import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Wallet, LogOut, User as UserIcon, LayoutDashboard, ArrowUpCircle, ClipboardList } from "lucide-react";

export const AppHeader = ({ back = false }) => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/", { replace: true });
  };

  return (
    <header data-testid="app-header" className="sticky top-0 z-40 backdrop-blur-xl bg-[#0a0a0c]/85 border-b border-white/5">
      <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3">
        <Link to="/" className="flex items-baseline gap-0.5">
          <span className="font-heading font-black text-xl tracking-tighter text-white">AZMIEY</span>
          <span className="font-heading font-black text-xl tracking-tighter text-violet-500">STORE</span>
        </Link>

        <div className="flex items-center gap-2">
          {user && user !== false && user.role !== "admin" && (
            <>
              <div data-testid="header-balance" className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-xl bg-violet-500/10 border border-violet-500/25">
                <Wallet className="w-4 h-4 text-violet-300" />
                <span className="text-sm font-mono text-white">RM {Number(user.balance || 0).toFixed(2)}</span>
              </div>
              <Link to="/dashboard" data-testid="nav-dashboard" className="hidden sm:inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] text-sm">
                <LayoutDashboard className="w-4 h-4" /> Dashboard
              </Link>
              <Link to="/topup" data-testid="nav-topup" className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-violet-600 hover:bg-violet-500 text-sm font-medium">
                <ArrowUpCircle className="w-4 h-4" /> Top Up
              </Link>
              <button onClick={doLogout} data-testid="nav-logout" className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] text-sm">
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">Keluar</span>
              </button>
            </>
          )}
          {(!user || user === false) && (
            <>
              <Link to="/login" data-testid="nav-login" className="px-3 py-2 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] text-sm">Log Masuk</Link>
              <Link to="/register" data-testid="nav-register" className="px-3 py-2 rounded-xl bg-violet-600 hover:bg-violet-500 text-sm font-medium">Daftar</Link>
            </>
          )}
          <Link to="/orders" data-testid="nav-orders" className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-white/10 bg-white/[0.03] hover:bg-white/[0.08] text-sm">
            <ClipboardList className="w-4 h-4 text-violet-400" /> Order
          </Link>
        </div>
      </div>
      {user && user !== false && user.role !== "admin" && (
        <div className="sm:hidden border-t border-white/5 px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-2 text-sm">
            <UserIcon className="w-4 h-4 text-zinc-400" />
            <span className="text-zinc-300">{user.name || user.email}</span>
          </div>
          <div className="flex items-center gap-2 px-2 py-1 rounded-lg bg-violet-500/10 border border-violet-500/25">
            <Wallet className="w-3.5 h-3.5 text-violet-300" />
            <span className="text-xs font-mono text-white">RM {Number(user.balance || 0).toFixed(2)}</span>
          </div>
        </div>
      )}
    </header>
  );
};

export default AppHeader;
